import { render, staticRenderFns } from "./layout-product-gallery.vue?vue&type=template&id=55f0eb7e&scoped=true"
import script from "./layout-product-gallery.vue?vue&type=script&lang=js"
export * from "./layout-product-gallery.vue?vue&type=script&lang=js"
import style0 from "./layout-product-gallery.vue?vue&type=style&index=0&id=55f0eb7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f0eb7e",
  null
  
)

export default component.exports